// extracted by mini-css-extract-plugin
module.exports = {"icon":"hamburger__icon___37cEI","active":"hamburger__active___3Wt9i"};